const DEBUG_KEY = 'cursorAgent.debug';

/** When true, Cursor Agent calls log to the console and the UI may show extra detail. */
export function isCursorAgentDebugEnabled(): boolean {
  try {
    if (localStorage.getItem(DEBUG_KEY) === '1') return true;
  } catch {
    /* ignore */
  }
  return import.meta.env.DEV;
}

export function setCursorAgentDebugEnabled(on: boolean): void {
  try {
    if (on) localStorage.setItem(DEBUG_KEY, '1');
    else localStorage.removeItem(DEBUG_KEY);
  } catch {
    /* ignore */
  }
}

export function cursorAgentLog(label: string, detail?: unknown): void {
  if (!isCursorAgentDebugEnabled()) return;
  if (detail === undefined) console.log('[CursorAgent]', label);
  else console.log('[CursorAgent]', label, detail);
}
